import React, { useEffect, useState, useRef, createRef, useContext, lazy } from 'react';

import useStyles from './styles';

import Header from '../../components/Header';
import RoomCard from '../../components/RoomCard';
import Loading from '../../components/Loading';
import SubpagePicker from '../../components/SubpagePicker';

import AppContext from '../../redux/contexts/appContext';

function Layout({cards, onRoomRemove, loading, loadingAmount}) {
  const classes = useStyles();
  const {state, dispatch} = useContext(AppContext);
  const [actualTab, setActualTab] = useState(0)

  useEffect(() => {
    document.title = "Home - Easy Scrum"
  }, [])

  return (
    <>
      <Header roomJoin></Header>
      <h1 style={{display: 'none'}}>Easy Scrum</h1>
        <div className={classes.pageContainer + " container"}>
          <h2>Rooms</h2>
          <SubpagePicker pages={[{name: "All Rooms"}, {name: "Your Rooms"}, {name: "Shared With You"}]} actualPageIndex={actualTab} onChange={(e) => setActualTab(e)}></SubpagePicker>
          

          {loading == false && (actualTab === 0 && (!cards?.all || cards?.all.length == 0)) || (actualTab === 1 && (!cards?.yourRooms || cards?.yourRooms.length == 0)) || (actualTab === 2 && (!cards?.sharedWithYou || cards?.sharedWithYou.length == 0)) ? 
           <span style={{color: 'rgba(0,0,0,0.5)', width: '100%', display: 'flex'}}>No rooms found</span>
          : false}

          {loading && (
            <section>
                <div className={classes.boardsArea}>
                  {loadingAmount.map((card, cardIdx) => {
                    return <RoomCard isLoading={true} key={"loading-card-"+cardIdx}  title={""} code={""} id={""} description={""} creatorId={""}></RoomCard>
                  })}
                </div>
            </section>
          )}
          
          {/* RENDERING ALL */}
          {actualTab === 0 && cards?.all && cards?.all.length > 0 && (
            <section>
                <div className={classes.boardsArea}>
                {cards?.all?.map((card, cardIdx) => {
                  return <RoomCard key={"home-card-"+cardIdx} onRoomRemove={onRoomRemove}  title={card.title} code={card.roomCode} id={card._id} description={card.description} creatorId={card.creatorId}></RoomCard>
                })}
                </div>
            </section>
          )}

          {/* RENDERING YOUR ROOMS */}
          {actualTab === 1 && cards?.yourRooms && cards?.yourRooms.length > 0 && (
            <section>
                <div className={classes.boardsArea}>
                {cards?.yourRooms?.map((card, cardIdx) => {
                  return <RoomCard key={"home-card-2-"+cardIdx} onRoomRemove={onRoomRemove}  title={card.title} code={card.roomCode} id={card._id} description={card.description} creatorId={card.creatorId}></RoomCard>
                })}
                </div>
            </section>
          )}
          
          {/* RENDERING SHARED WITH YOU ROOMS */}
          {actualTab === 2 && cards?.sharedWithYou && cards?.sharedWithYou.length > 0 && (
            <section>
                <div className={classes.boardsArea}>
                {cards?.sharedWithYou?.map((card, cardIdx) => {
                  return <RoomCard key={"home-card-3-"+cardIdx} onRoomRemove={onRoomRemove}  title={card.title} code={card.roomCode} id={card._id} description={card.description} creatorId={card.creatorId}></RoomCard>
                })}
                </div>
            </section>
          )}      

        </div>
     

    </>
    );
}

export default Layout;